import { ChevronDown, Globe, Lock } from 'lucide-react'
import type { ComponentProps } from 'react'

import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'

import { SnippetShareSwitches } from '../SnippetShareSwitches'
import type { SharingState } from './model'

const SHARING_LABEL: Record<SharingState, string> = {
  private: 'Private',
  shared: 'Shared with all orgs',
  sharedHidden: 'Shared · Hidden',
}

/** The row's sharing as a chip; the switches edit the draft, saved with it. */
export function SharingChip({
  state,
  className,
  ...switches
}: ComponentProps<typeof SnippetShareSwitches> & {
  state: SharingState
  className?: string
}) {
  const label = SHARING_LABEL[state]
  const Icon = state === 'private' ? Lock : Globe
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="xs"
          aria-label={`Sharing: ${label}`}
          className={cn(
            state !== 'private' &&
              'border-primary-subtle-border bg-primary-ui-bg text-primary-solid',
            className
          )}>
          <Icon aria-hidden="true" />
          {label}
          <ChevronDown aria-hidden="true" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 px-3 py-0">
        <SnippetShareSwitches {...switches} />
      </PopoverContent>
    </Popover>
  )
}
